import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SplashScreenComponent } from './components/splash-screen/splash-screen.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { MemeBattleComponent } from './meme-battle/meme-battle.component';


const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule),
    data: { page: 'homepage' }
  },
  { path: 'memebattle', component: MemeBattleComponent },
  {
    path: 'shorts',
    redirectTo: 'shorts-list',
    pathMatch: 'full'
  },
  // {
  //   path: 'splash',
  //   component: SplashScreenComponent
  // },
  {
    path: 'users/reset_password_email',
    component: ChangePasswordComponent
  },
  {
    path: 'signin',
    loadChildren: () => import('./components/home/home-routing.module').then(m => m.HomeRoutingModule)
  },

  { 
    path: 'rentalPayment', 
    loadChildren: () => import('./components/payment/rental-payment/rental-payment.module').then(m => m.RentalPaymentModule)
  },
  { path: 'payments/payment-pending', 
    loadChildren: () => import('./components/payment/payment-pending/payment-pending.module').then(m => m.PaymentPendingModule)
   },

  {
    path: 'live-tv',
    loadChildren: () => import('./components/epg/epg.module').then(m => m.EpgModule)
  },
  // {
  //   path: 'all-channels/:videoname',
  //   loadChildren: () => import('./components/livetv/livetv.module').then(m => m.LivetvModule),
  //   data: { page: 'livetv'}
  // },
  {
    path: 'plans',
    loadChildren: () => import('./components/plans/plans.module').then(m => m.PlansModule)
  },
  {
    path: 'tv',
    loadChildren: () => import('./components/activate-tv/activate-tv.module').then(m => m.ActivateTvModule)
  },
  {
    path: 'users/watchlist',
    loadChildren: () => import('./components/user/user.module').then(m => m.UserModule),
    data: { page: 'watchlist'}
  },
  { 
    path: 'users/watchlist/all/:theme',
    loadChildren: () => import('./components/user/user.module').then(m => m.UserModule),
    data: { page: 'watchlist-all'}
  },
  {
    path:'starrer/:id',
    loadChildren: () => import('./components/starring-details/starring-details.module').then(m => m.StarringDetailsModule),
    data: { page: 'star-details'}
   },
   {
    path:'starrer/:id/:type/all',
    loadChildren: () => import('./components/starring-details/starring-details.module').then(m => m.StarringDetailsModule),
    data: { page: 'starring-see-all'}
   },
  {
    path: 'users/continue_watching',
    loadChildren: () => import('./components/user/user.module').then(m => m.UserModule),
    data: { page: 'continue_watching'}
  },
  {
    path: 'about-us',
    loadChildren: () => import('./components/staticpage/staticpage.module').then(m => m.StaticpageModule),
    data: { page: 'about'}
  },
  {
    path: 'content_redressal_mechanism',
    loadChildren: () => import('./components/staticpage/staticpage.module').then(m => m.StaticpageModule),
    data: { page: 'content'}
  },
  {
    path: 'meta-pixel-page',
    loadChildren: () => import('./components/meta-pixel-page/meta-pixel-page.module').then(m => m.MetaPixelPageModule),
  },
    {
    path: 'app-plans',
    loadChildren: () => import('./components/android-plans-page/android-plans-page.module').then(m => m.AndroidPlansPageModule),
  },
  {
    path: 'coming-soon',
    loadChildren: () => import('./components/coming-soon/coming-soon.module').then(m => m.ComingSoonModule)
  },
  {
    path: 'privacy_policy',
    loadChildren: () => import('./components/staticpage/staticpage.module').then(m => m.StaticpageModule),
    data: { page: 'pp'}
  },
  {
    path: 'terms_and_conditions',
    loadChildren: () => import('./components/staticpage/staticpage.module').then(m => m.StaticpageModule),
    data: { page: 'tc'}
  },
  {
    path: 'faq',
    loadChildren: () => import('./components/staticpage/staticpage.module').then(m => m.StaticpageModule),
    data: { page: 'faq'}
  },
  {
    path: 'contact-us',
    loadChildren: () => import('./components/staticpage/staticpage.module').then(m => m.StaticpageModule),
    data: { page: 'contact'}
  },
  {
    path: 'refund_policy',
    loadChildren: () => import('./components/staticpage/staticpage.module').then(m => m.StaticpageModule),
    data: { page: 'refund_policy'}
  },
    {
    path: 'digital-delivery-exchange',
    loadChildren: () => import('./components/staticpage/staticpage.module').then(m => m.StaticpageModule),
    data: { page: 'digital-delivery-exchange'}
  },
  {
    path: 'tv-about-us',
    loadChildren: () => import('./components/tv-static-pages/tv-static-pages.module').then(m => m.TvStaticPagesModule),
    data: { page: 'tv-about'}
  },
  {
    path: 'tv-contact-us',
    loadChildren: () => import('./components/tv-static-pages/tv-static-pages.module').then(m => m.TvStaticPagesModule),
    data: { page: 'tv-contact'}
  },
  {
    path: 'tv-privacy_policy',
    loadChildren: () => import('./components/tv-static-pages/tv-static-pages.module').then(m => m.TvStaticPagesModule),
    data: { page: 'tv-pp'}
  },
  {
    path: 'tv-faq',
    loadChildren: () => import('./components/tv-static-pages/tv-static-pages.module').then(m => m.TvStaticPagesModule),
    data: { page: 'tv-faq'}
  },
  {
    path: 'tv-terms_and_conditions',
    loadChildren: () => import('./components/tv-static-pages/tv-static-pages.module').then(m => m.TvStaticPagesModule),
    data: { page: 'tv-tc'}
  },
  {
    path: 'sursangram',
    loadChildren: () => import('./components/sursangram/sursangram.module').then(m => m.SursangramModule),
    data: { page: 'sursangrampage'}
  },
  {
    path: 'awards',
    loadChildren: () => import('./components/awards/awards.module').then(m => m.AwardsModule),
    data: { page: 'awards'}
  },
  // PaymentFailureModule
  {
    path: 'payments/payment_success',
    loadChildren: () => import('./components/payment/payment-success/payment-success.module').then(m => m.PaymentSuccessModule),
  },
  {
    path: 'payments/payment_failure',
    loadChildren: () => import('./components/payment/payment-failure/payment-failure.module').then(m => m.PaymentFailureModule),
  },
  {
    path: 'payments/payment_stripe',
    loadChildren: () => import('./components/payment/payment-stripe/payment-stripe.module').then(m => m.PaymentStripeModule),
  },
  {
    path: ':catalogname/:itemname/play',
    loadChildren: () => import('./components/videopopup/videopopup.module').then(m => m.VideopopupModule)
  },
  {
    path: ':catalog_name/:show_name/:episode_name/play',
    loadChildren: () => import('./components/videopopup/videopopup.module').then(m => m.VideopopupModule)
  },
  {
    path: ':catalogname',
    loadChildren: () => import('./components/showcatalog/showcatalog.module').then(m => m.ShowcatalogModule),
    data: { page: 'cataloglist'}
  },
  {
    path: ':catalogname/all',
    loadChildren: () => import('./components/allitemslist/allitemslist.module').then(m => m.AllitemslistModule),
    data: { page: 'allitemlist'}
  },
  {
    path: ':catalogname/others/all',
    loadChildren: () => import('./components/allitemslist/allitemslist.module').then(m => m.AllitemslistModule),
    data: { page: 'othertvshows'}
  },
  {
    path: ':catalogname/:genre/all',
    loadChildren: () => import('./components/allitemslist/allitemslist.module').then(m => m.AllitemslistModule),
    data: { page: 'genreall'}
  },
  {
    path: ':catalogname/:showname/episodes',
    loadChildren: () => import('./components/all-episodes/all-episodes.module').then(m => m.AllEpisodesModule),
    data: { page: 'allepisdoes'}
  },
  {
    path: ':catalogname/:showname/:season/episodes',
    loadChildren: () => import('./components/all-episodes/all-episodes.module').then(m => m.AllEpisodesModule),
    data: { page: 'seasonepisdoes'}
  },
  {
    path: ':catalogname/:itemname',
    loadChildren: () => import('./components/details-redirection/details-redirection.modue').then(m => m.DetailsRedirectionModule),
  },
  {
    path: ':catalog_name/:show_name/:episode_name',
    loadChildren: () => import('./components/episodedetails/episodedetails.module').then(m => m.EpisodedetailsModule),
    data: { page: 'episodedetailspage'}
  },
  { path: '**/*', pathMatch: 'full', 
    loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule),
    data: { page: 'homepage' }
  },
 
];


// @NgModule({
//   imports: [
//     RouterModule.forRoot(appRoutes, {onSameUrlNavigation: 'reload'})
//   ],
//   exports: [RouterModule]
// })
@NgModule({
  imports: [
      RouterModule.forRoot(appRoutes, { useHash: false, onSameUrlNavigation: 'reload'})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
